export default "__VITE_ASSET__e008a80a__"